import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import {
  Actions,
  Getters,
  Mutations,
  ModalTieredPointsState,
} from '@/interfaces/store/modalTieredPoints'
import { RootState } from '@/interfaces/store/root'

export const state: ModalTieredPointsState = {
  isModalActive: false,
}

export const getters: GetterTree<ModalTieredPointsState, RootState> & Getters = {}
export const actions: ActionTree<ModalTieredPointsState, RootState> & Actions = {
  onOpen({ commit }) {
    commit('updateModalActive', true)
  },
  onClose({ commit }) {
    setTimeout(() => {
      commit('updateModalActive', false)
    }, 500)
  }
}

export const mutations: MutationTree<ModalTieredPointsState> & Mutations = {
  updateModalActive(state: ModalTieredPointsState, isModalActive: boolean) {
    state.isModalActive = isModalActive
  },
  updateModalClose(state: ModalTieredPointsState, isModalClose: boolean) {
    state.isModalActive = isModalClose
  },
}

export const store: Module<ModalTieredPointsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
